<template>
    
    <v-card>
        <v-container>
            <s-crud 
                add
                @save="save($event)"
                edit
                height="auto" 
                remove
                title="Lista de Opciones"
                :config="config"
                :filter="filter"
                searchInput
                close
                @close="$emit('close')"
                ref = "ScrudOptionsCheck"
            >

            <template v-slot:filter>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <s-select-definition
                                label="Nivel"
                                :def="1137"
                                clearable
                                v-model="filter.CldLevel"
                            ></s-select-definition>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template scope="props">
                <v-row>
                    <v-col cols="12" sm="12" md="12" class="pb-0">
                        <s-text class="s-col-form" label="Opción" placeholder="Nueva Opción" v-model="props.item.CldName"></s-text>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                        <s-select-definition
                            label="Nivel"
                            :def="1137"
                            v-model="props.item.CldLevel"
                            style="padding-left:12px; padding-right: 12px;"
                        ></s-select-definition>
                    </v-col>
                </v-row>
            </template>

            <template v-slot:CldChecked="{ row }">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            :color="row.CldStatus === 1 ? 'green' : 'red'"
                            icon
                            @click="toggleApproval(row)"
                            style="margin: 0; padding: 0; height: 32px; width: 32px;"
                        >
                            <v-icon dark>
                                {{ row.CldStatus === 1 ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline' }}
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>{{ row.CldStatus === 1 ? 'Aprobado' : 'Por Aprobar' }}</span>
                </v-tooltip>
            </template>
            </s-crud>
        </v-container>
    </v-card>
</template>

<script>
import _sCheckListDetailService from '@/services/Utility/CheckListDetailService';

	export default {
		props: {
			item : {
                type: Object,
                default: () => {}
            },
        },
		data() {
			return {
                filter : {},
                items: [],
                selected: [],
                RtkStatus: false,
                config : {
                    service: _sCheckListDetailService,
                    model: {
                        CldID: "ID",
                    },
                    headers: [
                        { text: 'ID', value: 'CldID', width: 50 },
                        { text: 'Verificar', value: 'CldChecked', width: 100},
                        { text: 'Nombre', value: 'CldName' },
                        { text: 'Nivel', value: 'CldLevelName' }
                    ]
                },
			};
		},
		methods: {
            save(item) {

                if(item.CldName == "") {
                    this.$fun.alert("Debes ingresar una opcion", "warning");
                    return;
                }

                item.CktID = this.item.CktID; 
                item.save();
            },
            toggleApproval(item) {
                item.CldStatus = item.CldStatus === 1 ? 0 : 1;
                _sCheckListDetailService.save(item, this.$fun.getUserID())
                    .then(resp => {
                        if (resp.status === 200) {
                            this.$fun.alert("Estado actualizado correctamente", "success");
                        } else {
                            this.$fun.alert("Error al actualizar estado", "error");
                        }
                    })
                    .catch(() => {
                        this.$fun.alert("Error de conexión", "error");
                    });
            }
		},
        mounted (){
            this.filter.CktID = this.item.CktID;
        }
	};
</script>